export const TIME_SLOTS = [
  { value: "08:00-10:00", label: "Morning · 8:00 – 10:00" },
  { value: "10:00-12:00", label: "Late morning · 10:00 – 12:00" },
  { value: "12:00-14:00", label: "Midday · 12:00 – 14:00" },
  { value: "14:00-16:00", label: "Afternoon · 14:00 – 16:00" },
  { value: "16:00-18:00", label: "Late afternoon · 16:00 – 18:00" },
];
